import {createGlobalStyle} from 'styled-components';

export const GlobalBeamerStyles = createGlobalStyle`
    /*  Beamer automatically injects an element in the DOM when there's something new to highlight to the user.
        We already disable some of this logic in app/api/beamer-api.ts by disabling the Beamer Button, but
        this isn't enough.
     */
    #beamerLastPostTitle {
        &&& {
            display: none !important;
        }
    }
`;
